module.exports = __webpack_public_path__ + "img/arrow_up_3.cffd28cd.svg";